module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Sun-b449201f8984b4c903cf879d18bead65.svg";